import { render, staticRenderFns } from "./MypageTopPage.vue?vue&type=template&id=b2c09c18&scoped=true"
import script from "./MypageTopPage.vue?vue&type=script&lang=ts"
export * from "./MypageTopPage.vue?vue&type=script&lang=ts"
import style0 from "./MypageTopPage.vue?vue&type=style&index=0&id=b2c09c18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c09c18",
  null
  
)

export default component.exports